import { defineMessages } from 'react-intl'

export default defineMessages({
  heading: {
    defaultMessage: 'Skicka in feedback',
    id: 'feedback.heading',
  },
  instructions: {
    defaultMessage: 'Svara på skalan 0 till 10 genom att klicka på en siffra nedan.',
    id: 'feedback.instructions',
  },
  currentResultHeading: {
    defaultMessage: 'Din nuvarande bedömning',
    id: 'feedback.current-result-heading',
  },
  feedbackHeading: {
    defaultMessage: 'Kommentarer till ditt svar (ej obligatorisk)',
    id: 'feedback.feedback-heading',
  },
  cta: {
    defaultMessage: 'Skicka feedback',
    id: 'feedback.cta',
  },
  ctaUpdate: {
    defaultMessage: 'Uppdatera',
    id: 'feedback.cta-update',
  },
  alert: {
    defaultMessage: 'Du måste ange en poäng mellan 0 och 10',
    id: 'feedback.alert',
  },
})
